// src/components/LevelResumePrompt.jsx
import React from "react";

export default function LevelResumePrompt({
  open,
  progress,
  loading = false,
  onContinue,
  onNotNow,
}) {
  if (!open || !progress) return null;

  const levelName =
    String(progress.level_title || "").trim() ||
    String(progress.level_key || "this level");

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/45 px-4">
      <div className="w-full max-w-[340px] rounded-[24px] bg-white px-6 py-7 text-center shadow-2xl">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#FFF1E8] text-3xl">
          ▶️
        </div>

        <h2 className="mt-4 text-[24px] font-bold leading-tight text-[#333333]">
          Continue where you left off?
        </h2>

        <p className="mt-3 text-[14px] leading-relaxed text-[#757575]">
          You have an unfinished level in{" "}
          <span className="font-bold text-[#333333]">{levelName}</span>.
          Would you like to continue from where you stopped?
        </p>

        <button
          type="button"
          onClick={onContinue}
          disabled={loading}
          className={[
            "mt-5 flex h-[44px] w-full items-center justify-center rounded-[10px] px-4 text-[15px] font-bold text-white",
            loading
              ? "cursor-not-allowed bg-[#BCBCBC]"
              : "bg-[#FF914D] hover:bg-[#E9782F]",
          ].join(" ")}
        >
          {loading ? "CHECKING..." : "CONTINUE LEVEL"}
        </button>

        <button
          type="button"
          onClick={onNotNow}
          disabled={loading}
          className="mt-3 flex h-[42px] w-full items-center justify-center rounded-[10px] border border-[#FFD7BF] bg-white px-4 text-[14px] font-bold text-[#FF914D] disabled:cursor-not-allowed disabled:opacity-60"
        >
          NOT NOW
        </button>
      </div>
    </div>
  );
}